/* AV metal sheen driver: ONE travelling light field shared by ALL .bar-segments
   (product rows + date pills + timeline), so the shine sweeps continuously through
   the whole day group instead of sitting fixed in the middle of every bar.
   Band position = viewport-space light (rows lower on screen sample a shifted phase
   -> one coherent diagonal sweep that MOVES as you scroll) + slow autonomous drift
   (alive even when idle) + gyro tilt on mobile + a small per-element random seed
   (no two bars ever identical). Writes --av-shn1/--av-shn2, consumed by
   .bar-segments::after in latest-templates.css. */
(function () {
  'use strict';
  if (window.__avSheen) return; window.__avSheen = 1;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var coarse = window.matchMedia && matchMedia('(hover:none),(pointer:coarse)').matches;
  var els = [], drift = 0, gx = 0, gTgt = 0, lastT = 0, lastQ = 0, raf = 0;

  function collect() {
    els = [].slice.call(document.querySelectorAll('.bar-segments'));
    for (var i = 0; i < els.length; i++) if (els[i].__shSeed === undefined) els[i].__shSeed = Math.random();
  }

  if (coarse && window.DeviceOrientationEvent) {   // MOBILE: the light leans with the phone (slow-adapting neutral like the other engines)
    var gyB = null;
    var gyOn = function (e) { var g = e.gamma; if (g == null) return; if (gyB === null) gyB = g; gyB += (g - gyB) * 0.006; gTgt = Math.max(-24, Math.min(24, g - gyB)) / 24; };
    var gyGo = function () { window.addEventListener('deviceorientation', gyOn, { passive: true }); };
    if (typeof DeviceOrientationEvent.requestPermission === 'function') { var gyReq = function () { window.removeEventListener('touchend', gyReq); (window.__avGyPr || (window.__avGyPr = DeviceOrientationEvent.requestPermission())).then(function (s) { if (s === 'granted') gyGo(); })['catch'](function () { }); }; window.addEventListener('touchend', gyReq, { passive: true }); }
    else gyGo();
  }

  function tick(t) {
    raf = requestAnimationFrame(tick);
    if (t - lastT < 33) return;   // ~30fps is plenty for a light sweep
    var dt = Math.min(0.1, (t - lastT) / 1000) || 0.033; lastT = t;
    if (t - lastQ > 1200) { lastQ = t; collect(); }   // picks up rebuilt rows (pagination/mutations) without observers
    drift += dt * 34;
    gx += (gTgt - gx) * 0.08;
    var vh = window.innerHeight || 800;
    for (var i = 0; i < els.length; i++) {
      var el = els[i], r = el.getBoundingClientRect();
      if (r.bottom < -120 || r.top > vh + 120 || r.width < 4) continue;
      var w = r.width;
      var b1 = Math.min(340, w * 0.62), b2 = Math.min(760, w * 1.4);   // mirror the CSS min() band widths so the wrap maths matches what is drawn
      var base = drift + gx * 260 - r.top * 0.6 + el.__shSeed * 90;
      var p1 = w + b1, p2 = w + b2 + 240;   // cycle = travel + exactly one band width -> the main band is (partially) visible at every moment, it only fully hides for the instant of the seamless right->left wrap; the soft band keeps a short 240px pause
      var x1 = ((base % p1) + p1) % p1 - b1;
      var x2 = (((base * 0.55 + el.__shSeed * 1100) % p2) + p2) % p2 - b2;
      el.style.setProperty('--av-shn1', x1.toFixed(1) + 'px');
      el.style.setProperty('--av-shn2', x2.toFixed(1) + 'px');
    }
  }

  function start() { if (!raf) { lastT = 0; raf = requestAnimationFrame(tick); } }
  function stop() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }
  document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { collect(); start(); });
  else { collect(); start(); }
})();
